import { reactive } from '@vue/composition-api'
import { fetchBalance } from '@ms/api/user'

export default function useWalletStore() {
  const wallet = reactive({
    balance: ''
  })

  const updateBalance = (val) => {
    wallet.balance = val / 10000
  }

  const getBalance = async () => {
    const avlBal = await fetchBalance()
    updateBalance(avlBal)
    return wallet.balance
  }

  return {
    wallet,
    updateBalance,
    getBalance
  }
}
